if (!customElements.get('collection-carousel')) {
  customElements.define(
    'collection-carousel',
    class CollectionCarousel extends HTMLElement {
      constructor() {
        super();
        this.viewportNode = this.querySelector('.custom-featured-collection__slider-viewport');
        this.prevBtnNode = this.querySelector('.custom-featured-collection__prev');
        this.nextBtnNode = this.querySelector('.custom-featured-collection__next');

        this.embla = EmblaCarousel(this.viewportNode, { align: 'start', slidesToScroll: 1 });
        this.prevBtnNode.addEventListener('click', this.previous.bind(this), false);
        this.nextBtnNode.addEventListener('click', this.next.bind(this), false);

        this.embla
          .on('select', this.togglePrevNextBtnsState.bind(this))
          .on('init', this.togglePrevNextBtnsState.bind(this))
          .on('reInit', this.togglePrevNextBtnsState.bind(this));
      }

      previous(e) {
        e.preventDefault();
        this.embla.scrollPrev();
      }

      next(e) {
        e.preventDefault();
        this.embla.scrollNext();
      }

      togglePrevNextBtnsState() {
        if (this.embla.canScrollPrev()) {
          this.prevBtnNode.classList.remove('arrow-button--disabled');
        } else {
          this.prevBtnNode.classList.add('arrow-button--disabled');
        }

        if (this.embla.canScrollNext()) {
          this.nextBtnNode.classList.remove('arrow-button--disabled');
        } else {
          this.nextBtnNode.classList.add('arrow-button--disabled');
        }
      }
    },
  );
}
